import { Component, OnInit } from '@angular/core';
import { EnterpriseService } from '../enterprise.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { TrustPilotComponent } from 'src/app/shared/components/trust-pilot/trust-pilot.component';

@Component({
  selector: 'app-enterprise-casestudy',
  templateUrl: './case-study.component.html',
  imports: [CommonModule, ToHtmlPipe,TrustPilotComponent],
})
export class EnterpriseCaseStudyComponent implements OnInit {
  customerstateData:any;
  constructor(
    private enterpriseService: EnterpriseService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router
  ) {
    this.getUrl = this.router.url;
  }

  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  ngOnInit(): void {
    let data = this.route.snapshot.data?.['seo']?.[0].fields;
    this.customerstateData = data?.caseStudyContentPanel?.[0]?.fields;
  }
}
